import React from "react";
import SubsectionHeader from "@/components/shared/SubsectionHeader";
import Footer from "@/components/Footer";

const JoinPage: React.FC = () => {
  const positions = [
    {
      title: "金鱼养殖技术专家",
      responsibilities: [
        "负责金鱼养殖技术的研究和创新",
        "制定养殖标准和操作规范",
        "为客户提供技术咨询和指导",
        "参与技术培训课程的开发",
      ],
      requirements: [
        "具有5年以上金鱼养殖经验",
        "熟悉各类金鱼品种的特性和养殖要求",
        "具有良好的沟通能力和团队协作精神",
        "有相关技术研究成果者优先",
      ],
    },
    {
      title: "技术研发工程师",
      responsibilities: [
        "负责养殖设备和系统的研发",
        "开发和优化养殖监控系统",
        "参与技术方案的设计和实施",
        "编写技术文档和使用手册",
      ],
      requirements: [
        "本科及以上学历，计算机或相关专业",
        "熟悉常用编程语言和开发工具",
        "有物联网或智能设备开发经验者优先",
        "具有良好的学习能力和创新精神",
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <div className="px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <SubsectionHeader
          title="加入我们"
          description="与我们一起，打造金鱼养殖的未来"
          icon="Users"
          variant="hero"
        />

        {/* 公司文化 */}
        <section className="mx-auto max-w-3xl py-6 sm:py-8">
          <h2 className="mb-4 text-center text-xl sm:text-2xl font-semibold text-foreground">
            公司文化
          </h2>
          <div className="prose prose-sm sm:prose-base dark:prose-invert leading-relaxed mx-auto">
            <p>
              我们崇尚创新、追求卓越，致力于为每一位员工提供广阔的发展平台和优质的工作环境。
              在这里，你将有机会参与到金鱼养殖技术的创新与发展中，与行业内的专家一起工作，实现自己的职业理想。
            </p>
          </div>
        </section>

        {/* 招聘岗位 */}
        <section className="mx-auto max-w-3xl py-6 sm:py-8">
          <h2 className="mb-6 text-center text-xl sm:text-2xl font-semibold text-foreground">
            招聘岗位
          </h2>
          <div className="space-y-6">
            {positions.map((position) => (
              <div
                key={position.title}
                className="rounded-2xl border border-border bg-card p-5 sm:p-6 shadow-sm"
              >
                <h3 className="text-lg font-semibold text-foreground mb-4">
                  {position.title}
                </h3>
                <div className="mb-4">
                  <p className="text-sm font-medium text-foreground mb-2">
                    岗位职责：
                  </p>
                  <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
                    {position.responsibilities.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground mb-2">
                    任职要求：
                  </p>
                  <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
                    {position.requirements.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 投递简历 */}
        <section className="mx-auto max-w-3xl py-6 sm:py-8">
          <h2 className="mb-4 text-center text-xl sm:text-2xl font-semibold text-foreground">
            投递简历
          </h2>
          <div className="rounded-2xl border border-border bg-card p-5 sm:p-6 shadow-sm text-center">
            <p className="text-sm text-muted-foreground mb-3">
              如果您对以上职位感兴趣，欢迎将简历发送至：
            </p>
            <a
              href="mailto:hr@tunzo.com"
              className="text-primary font-semibold hover:underline"
            >
              hr@tunzo.com
            </a>
            <p className="text-sm text-muted-foreground mt-3">
              我们会在收到简历后尽快与您联系。
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default JoinPage;
